import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import ConsulateRelease from './municipality-release';
import { AccordionResidencyPermit as AccordionResidencyPermitVM } from 'shell/view-models/accordion-residency-permit';
import { FormikErrors, FormikTouched } from 'formik';
import TypeResidenceList from 'shell/components/shared/type-residence';
import { noop } from 'shell/utils/noop';

interface ResidencyPermitProps {
  disabled?: boolean;
  values?: AccordionResidencyPermitVM;
  onChange: (
    key: keyof AccordionResidencyPermitVM,
    value: AccordionResidencyPermitVM[keyof AccordionResidencyPermitVM]
  ) => void;
  errors?: FormikErrors<AccordionResidencyPermitVM>;
  touched?: FormikTouched<AccordionResidencyPermitVM>;
}

const ResidencyPermitComponent = ({
  disabled,
  values,
  onChange,
  errors,
  touched,
}: ResidencyPermitProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <PmiTextField
          label="Numero permesso"
          aria-label="Numero permesso"
          id="permit-number"
          fullWidth
          inputProps={{
            maxLength: '20',
          }}
          value={values?.number || ''}
          disabled
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TypeResidenceList
          label="Tipo *"
          aria-label="Tipo"
          onChange={noop}
          disabled
          value={values?.type || ''}
          error={touched?.type && Boolean(errors?.type)}
        />
      </Grid>
      {values?.type === '9' ? (
        <Grid item xs={12}>
          <PmiTextField
            label="Note"
            aria-label="Note"
            id="permit-note"
            fullWidth
            inputProps={{
              maxLength: '240',
            }}
            value={values?.note || ''}
            disabled
            multiline
            rows={3}
          />
        </Grid>
      ) : undefined}
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data rilascio"
          value={values?.releaseDate || null}
          disabled={disabled}
          onChange={noop}
          renderInput={(params) => (
            <PmiTextField {...params} id="releaseDate" fullWidth error={false} helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data scadenza"
          value={values?.expirationDate || null}
          disabled={disabled}
          onChange={noop}
          renderInput={(params) => (
            <PmiTextField {...params} id="expirationDate" fullWidth error={false} helperText="" />
          )}
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <PmiTextField
          label="Questura rilascio"
          aria-label="Questura rilascio"
          id="police-force-release"
          fullWidth
          inputProps={{
            maxLength: '50',
          }}
          value={values?.policeForceRelease || ''}
          disabled
        />
      </Grid>
      <ConsulateRelease disabledComponent values={values} onChange={onChange} />
    </Grid>
  );
};

ResidencyPermitComponent.displayName = 'Accordion Residency Permit component';

const ResidencyPermit = memo(ResidencyPermitComponent);

export default ResidencyPermit;
